function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("clipPath", {
  id: "gb_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0v30h60V0z"
}));

var _ref2 = /*#__PURE__*/React.createElement("clipPath", {
  id: "gb_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  d: "M30 15h30v15zv15H0zH0V0zV0h30z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#gb_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0v30h60V0z",
  fill: "#012169"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0l60 30m0-30L0 30",
  stroke: "#fff",
  strokeWidth: 6
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0l60 30m0-30L0 30",
  clipPath: "url(#gb_svg__b)",
  stroke: "#C8102E",
  strokeWidth: 4
}), /*#__PURE__*/React.createElement("path", {
  d: "M30 0v30M0 15h60",
  stroke: "#fff",
  strokeWidth: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M30 0v30M0 15h60",
  stroke: "#C8102E",
  strokeWidth: 6
}));

function SvgGb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 30"
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2MCAzMCI+PGNsaXBQYXRoIGlkPSJhIj48cGF0aCBkPSJNMCAwdjMwaDYwVjB6Ii8+PC9jbGlwUGF0aD48Y2xpcFBhdGggaWQ9ImIiPjxwYXRoIGQ9Ik0zMCAxNWgzMHYxNXp2MTVIMHpIMFYwelYwaDMweiIvPjwvY2xpcFBhdGg+PGcgY2xpcC1wYXRoPSJ1cmwoI2EpIj48cGF0aCBkPSJNMCAwdjMwaDYwVjB6IiBmaWxsPSIjMDEyMTY5Ii8+PHBhdGggZD0iTTAgMGw2MCAzMG0wLTMwTDAgMzAiIHN0cm9rZT0iI2ZmZiIgc3Ryb2tlLXdpZHRoPSI2Ii8+PHBhdGggZD0iTTAgMGw2MCAzMG0wLTMwTDAgMzAiIGNsaXAtcGF0aD0idXJsKCNiKSIgc3Ryb2tlPSIjQzgxMDJFIiBzdHJva2Utd2lkdGg9IjQiLz48cGF0aCBkPSJNMzAgMHYzME0wIDE1aDYwIiBzdHJva2U9IiNmZmYiIHN0cm9rZS13aWR0aD0iMTAiLz48cGF0aCBkPSJNMzAgMHYzME0wIDE1aDYwIiBzdHJva2U9IiNDODEwMkUiIHN0cm9rZS13aWR0aD0iNiIvPjwvZz48L3N2Zz4=";
export { SvgGb as ReactComponent };